import cx from "classnames";
import React, { useEffect, useRef } from "react";
import { Paragraph } from "@smartsuite/react-ui/lib/components/typography/Paragraph/Paragraph";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { Hotkeys } from "../Hotkeys/Hotkeys";
export const SlashSuggesterMenu = ({ commands, activeIndex, onCommand, }) => {
    const wrapperRef = useRef(null);
    useEffect(() => {
        var _a;
        (_a = wrapperRef.current
            .querySelector(".slash-suggester-menu__item--active")) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            block: "nearest",
        });
    }, [activeIndex]);
    const handleClick = (command) => (e) => {
        e.stopPropagation();
        onCommand(command);
    };
    const handleMouseDown = (e) => {
        e.preventDefault(); // avoid focus to go to menu when clicked, so editor doesn't lose focus
    };
    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", { ref: wrapperRef, className: "slash-suggester-menu", onMouseDown: handleMouseDown },
        React.createElement("div", { className: "slash-suggester-menu__list" }, commands.map((group) => (React.createElement("div", { key: group.name, className: "slash-suggester-menu__category" },
            React.createElement("div", { className: "slash-suggester-menu__category-label" },
                React.createElement(Paragraph, { size: "xs", weight: "semibold", color: "currentColor" }, group.name)),
            group.items.map((command) => (React.createElement("div", { key: command.label, className: cx("slash-suggester-menu__item", {
                    "slash-suggester-menu__item--active": command.index === activeIndex,
                }) },
                React.createElement("button", { className: "slash-suggester-menu__btn", onClick: handleClick(command) },
                    React.createElement("div", { className: "slash-suggester-menu__item-icon" },
                        React.createElement(Icon, { name: command.icon, size: (command === null || command === void 0 ? void 0 : command.iconSize) || "M", color: command.iconColor ? command.iconColor : "currentColor" })),
                    React.createElement("div", { className: "slash-suggester-menu__item-text" },
                        React.createElement(Paragraph, { size: "l", weight: "medium" }, command.label),
                        React.createElement(Paragraph, { size: "s", color: "secondary" }, command.description)),
                    command.shortcut && false && (React.createElement(Hotkeys, { className: "slash-suggester-menu__hotkeys", signKey: command.shortcut }))))))))))));
};
